import { mapActions, mapState } from 'vuex'
import { REGEXPS } from '@/common/const/regexp.const'
import { PAYMENT_METHOD_TYPE } from '@/common/const/payment.const'
import { BLIK0_SUPPORTED_BANKS } from '@/common/const/blik.const'
import { RESPONSE_STATUS } from '@/common/const/response.const'

export default {
  data () {
    return {
      showBlikBankNotSupported: false,
      blikBanks: BLIK0_SUPPORTED_BANKS,
      form: {
        token: '',
        isTokenValid: null,
        isTokenEmpty: true,
        isTokenDirty: false,
        isTokenTouched: false
      }
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.blik.loading,
      bankList: state => state.blik.systemConfiguration
    })
  },
  methods: {
    ...mapActions([
      'verifyBlik',
      'getBlikSystemConfiguration'
    ]),
    getBankIconUrl (icon) {
      return `background-image: url('${icon}')`
    },
    checkBlikCode () {
      this.setBlikCodeEmpty()
      this.setBlikCodeValid()
      this.form.isTokenDirty = true
      this.form.isTokenTouched = true
    },
    isBlikCodeError () {
      if (!this.form.isTokenTouched) {
        return false
      }
      return this.isBlikCodeEmpty() || !this.isBlikCodeValid() || this.showBlikBankNotSupported
    },
    setBlikCodeEmpty () {
      this.form.isTokenEmpty = !this.form.token || this.form.token.length === 0
    },
    isBlikCodeEmpty () {
      return this.form.isTokenEmpty
    },
    setBlikCodeValid () {
      this.form.isTokenValid = REGEXPS.blikNumber.test(this.form.token.replace(/ /g, ''))
    },
    isBlikCodeValid () {
      return this.form.isTokenValid
    },
    submit () {
      this.showBlikBankNotSupported = false
      if (!this.isBlikCodeValid()) {
        return
      }
      const data = {
        authorizationCode: this.form.token.replace(/ /g, ''),
        recurringAgree: true
      }
      this.verifyBlik(data)
        .then(response => {
          this.$notify.success({
            title: this.$t('component.blik.messges.addTokenSuccessHeader'),
            message: this.$t('component.blik.messges.addTokenSuccess')
          })
          const params = {
            ServiceID: response.serviceId,
            OrderID: response.orderId,
            Hash: response.hash,
            Source: PAYMENT_METHOD_TYPE.blikRecurring
          }
          this.$router.push({ name: 'creditCardBack', query: params })
        })
        .catch(error => {
          if (error === RESPONSE_STATUS.blikBankNotSupported) {
            this.showBlikBankNotSupported = true
            return
          }
          this.$notify.error({
            title: this.$t('component.blik.messges.addTokenErrorHeader'),
            message: this.$t('component.blik.messges.addTokenError')
          })
        })
    }
  },
  mounted () {
    this.getBlikSystemConfiguration()
      .finally(() => {
        this.$refs['blikCode'].focus()
      })
  }
}
